import { useEffect, useState } from "react"
import Breadcrumbs from "../../../../common/breadcrumb/Breadcrumbs"
import ListRole from "./listRole"
import { roleList } from "../../../../api/login/Login"
import { DatePicker } from "antd"


function ListMainRole() {
    const [userData, setUserData] = useState()
    const [dmtTtxn, setDmtTtxn] = useState([])
    const [dmtExcelTtxn, setDmtExcelTtxn] = useState()
    const [count, setCount] = useState(10)
    const [page, setPage] = useState(0)
    const token = window.localStorage.getItem('userToken')
    const [loading, setLoadig] = useState(false)
    const [total, setTotal] = useState()
    const [filters, setFilters] = useState({ name: "", start_date: '', end_date: '' });

    const [updateKey , setUpdateKey] = useState(false)

    const getDmtTxnData = async () => {
        setLoadig(true)

        let obj = {
            page ,
            count,
        }
        if(filters?.start_date)
        {
            obj.start_date = filters?.start_date?.format('YYYY-MM-DD') || ''
        }
        if(filters?.end_date)
            {
                obj.end_date = filters?.end_date?.format('YYYY-MM-DD') ||''
            }
            if(filters?.name)
                {
                    obj.name = filters?.name
                }
        try {
            const res = await roleList(obj);
            // console.log(res?.data);
            setDmtTtxn(res?.data);
          
            setTotal(res?.totalCount)
            setLoadig(false)
        } catch (error) {
            alert(error.message)
            setLoadig(false)
        }
    }


    const onChangeVal = (e) => {
        setPage(e - 1)
        // getDmtTxnData(e - 1)
    };
    useEffect(() => {
        getDmtTxnData()
     
    }, [page , updateKey])


    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
      };

      const handleDateChange = (field, date) => {
        setFilters({ ...filters, [field]: date });
      };  

    const applyFilter = () => {
        setPage(0)
        setUpdateKey((pre)=>!pre)
    };

    const handleReset = ()=>{
        setFilters({ name: '' ,  start_date: '', end_date: '' })
        setPage(0)
        setUpdateKey((pre)=>!pre)
    }

    return (
        <>
            <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Role & Permission",
    title_2: "List Role",
  }} />
  {/* //filter start */}

  <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>{' Role Search '} </b></h4>
                                </div>
                                <div className="row pt-2">
                                    <div className="col-md-4">
                                        <label>Name</label>
                                        <input type="text" name="name" value={filters?.name} className="form-control" onChange={handleFilterChange} />
                                    </div>
                                    <div className="col-md-4">
        <label>Start Date</label>
        <DatePicker
          value={filters.start_date}
          
          onChange={(date) => handleDateChange("start_date", date)}
          disabledDate={(current) => current && current > new Date()}
          placeholder="Select start date"
          className="custom-datepicker form-control"
        />
      </div>

      <div className="col-md-4">
        <label>End Date</label>
        <DatePicker
          value={filters.end_date}
          onChange={(date) => handleDateChange("end_date", date)}
          disabledDate={(current) => current && current > new Date()}
          placeholder="Select end date"
          className="custom-datepicker form-control"
        />
      </div>

                                    <div className="col-md-12 mt-3">
                                        <button className="btn btn-primary" onClick={applyFilter}>Submit</button>
                                        <button className="btn btn-info ml-3" onClick={handleReset}>Reset</button>
                                    </div>
                                </div>
                        
                                </div>
                                </div>
                                </div>
                                </div>
                                </div>
          {/* {filter end} */}
            <ListRole onChangeVal={onChangeVal} dmtTtxn={dmtTtxn} loading={loading} dmtExcelTtxn={dmtExcelTtxn} setUpdateKey={setUpdateKey} total={total} page={page} />
        </>
    )
}
export default ListMainRole